import { Fragment } from "react";
import { Field, FieldArray, getIn, useFormikContext } from "formik";

import Input from "Components/Form/Input";
import PanelContent from "Components/Panels/PanelContent";
import { useUnit } from "Pages/Units/useUnit";

const TRANSPORT_ITEM_FIELDS = ["transport"];

function isTransportItemComplete(item) {
  if (!item || item.deleted) return false;

  return TRANSPORT_ITEM_FIELDS.every((field) => {
    const value = item[field];
    return value !== undefined && value !== null && String(value).trim() !== "";
  });
}

function getLastActiveTransportIndex(transports = []) {
  let lastIndex = -1;

  transports.forEach((item, index) => {
    if (!item?.deleted) lastIndex = index;
  });

  return lastIndex;
}

function getVisibleTransportIndex(transports, index) {
  return transports.slice(0, index).filter((item) => !item.deleted).length;
}

function createTransportItem() {
  return {
    transport: "",
  };
}

async function validateTransportItem(index, setFieldTouched, validateField) {
  await Promise.all(
    TRANSPORT_ITEM_FIELDS.map(async (field) => {
      const path = `transports.${index}.${field}`;
      setFieldTouched(path, true, false);
      await validateField(path);
    })
  );
}

export function Transports() {
  const {
    values,
    setFieldValue,
    errors,
    handleChange,
    setFieldTouched,
    validateField,
  } = useFormikContext();

  const { handleDeleteTransport } = useUnit(null);

  const transports = values.transports ?? [];
  const hasTransportActive = transports.length >= 1;

  function getFieldError(index, field) {
    return getIn(errors, `transports.${index}.${field}`) ?? "";
  }

  const handleTransportChange = async (event, index) => {
    handleChange(event);

    if (getIn(errors, `transports.${index}.transport`)) {
      await validateField(`transports.${index}.transport`);
    }
  };

  return (
    <PanelContent title="Meios de Transporte">
      <section
        style={{
          display: "flex",
          flexWrap: "wrap",
          borderBottom: "1px dashed #E5E5E5",
          marginBottom: "2rem",
        }}
      >
        <FieldArray
          name="transports"
          render={({ push, remove }) => {
            const addNewTransport = async () => {
              setFieldValue("transport", true);

              const lastIndex = getLastActiveTransportIndex(transports);

              if (lastIndex === -1) {
                push(createTransportItem());
                return;
              }

              if (!isTransportItemComplete(transports[lastIndex])) {
                await validateTransportItem(
                  lastIndex,
                  setFieldTouched,
                  validateField
                );
                return;
              }

              push(createTransportItem());
            };

            const removeItem = (index, itemId) => {
              if (itemId) {
                handleDeleteTransport(itemId);
              }
              remove(index);
            };

            return (
              <>
                {hasTransportActive &&
                  transports.map((transportItem, index) => {
                    if (transportItem.deleted) return null;

                    const visibleIndex = getVisibleTransportIndex(
                      transports,
                      index
                    );

                    return (
                      <Fragment key={`transport-${index}`}>
                        <div className="xs-12">
                          <Field
                            component={Input}
                            name={`transports.${index}.transport`}
                            id={`transports.${index}.transport`}
                            label={`Endereço ${visibleIndex + 1}`}
                            type="text"
                            maxLength={255}
                            value={transports[index]?.transport ?? ""}
                            error={getFieldError(index, "transport")}
                            onChange={(event) =>
                              handleTransportChange(event, index)
                            }
                          />
                        </div>

                        <div className="xs-12 parking-itens-flex">
                          <div className="parking-grid-buttons">
                            <button
                              type="button"
                              onClick={() =>
                                removeItem(index, transportItem.id)
                              }
                              className="link link-danger"
                            >
                              Excluir
                            </button>
                          </div>
                        </div>
                      </Fragment>
                    );
                  })}

                <div
                  className="xs-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button
                    type="button"
                    className="button _white _icon-add"
                    style={{ marginBottom: "1rem" }}
                    onClick={addNewTransport}
                  >
                    <span className="represent-icon-holder">+</span>
                    Adicionar novo
                  </button>
                </div>
              </>
            );
          }}
        />
      </section>
    </PanelContent>
  );
}
